<template>
            <div class="header">
    </div>
    <div class="contenedor fondo text-center">
      <div class="d-flex justify-content-center align-items-center">
      <img src="@/assets/desafioConTarjetas.png" alt="" style="width: 80%;">
    </div>
    <div class="row mx-auto col-sm-12 desktop">
        <div>
            <img src="@/assets/naRegistrado.png" alt="" style="width:70%; margin-top:5%;">
        </div>
        <div>
          <button class="form-rounded btn-inscribir-nuevo align-self-stretch" v-on:click="validaCampoRegistrado()" style="width: 60%; margin: 2%">
            <span>INSCRÍBETE AL DESAFÍO HOY</span>
          </button>
      </div>

    </div>

</div>

</template>

<script>
import variables from '@/static/endPoint.json'

export default {
  name: 'noRegistrado',
    data() {
        return {
            isLoading:false,
            variables:variables
        }
    },
   created(){
      window.scrollTo(0,0);
    },
    methods:{
      validaCampoRegistrado(){
        this.$store.commit('SET_MOSTRAR_VALIDACION',true);
        this.$store.commit('SET_MOSTRAR_NOREGISTRADO',false);
      },
    },
}
</script>